import React, { useRef, useState, useEffect } from 'react';

import { IconButton, Grid } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import styled from 'styled-components';
import { StyledTypography, StyledTextField } from 'styles/common';

import { StyledFilterDisplay, ScrollableContainer, BlueButton, LastMenuItem, AbsoluteContainer } from '../styles';

const CustomFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon, index }) => {
  const [selected, setSelected] = useState([]);
  const [values, setValues] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const makeCurrentStateEqualToSelectedState = () => {
    setSelected(selectedFilters);
    setValues('');
  };

  const handleDeleteClick = (value) => {
    setSelected(selected.filter((v) => v !== value));
  };

  const handleTextChange = (e) => {
    setValues(e.target.value);
  };

  const handleAddClick = () => {
    setSelected([...selected, ...values.split(',')].map((v) => v.trim()).filter((v) => v));
    setValues('');
  };

  const handleApplyClick = () => {
    updateFilters(selected, filterName);
    setIsVisible(false);
  };

  const handleOpenClick = (e) => {
    e.stopPropagation();
    setIsVisible(!isVisible);
    makeCurrentStateEqualToSelectedState();
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <Container>
      <StyledFilterDisplay
        width="20%"
        icon={icon}
        name={filterName}
        selectedCount={selectedFilters.length}
        noLeftBorder={noLeftBorder}
        active={selectedFilters.length > 0}
        onClick={handleOpenClick}
        removeFilters={removeFilters}
        ref={buttonRef}
      />
      {isVisible && (
        <AbsoluteContainer ref={wrapperRef} middle={(index + 2) % 3 === 0} right={(index + 1) % 3 === 0}>
          <DropdownList>
            <StyledScrollableContainer>
              {selected &&
                selected.map((value) => (
                  <Grid container>
                    <BorderedGrid item xs={10}>
                      <StyledTypography varaint="body2" display="inline">
                        {value}
                      </StyledTypography>
                    </BorderedGrid>
                    <IconGrid item xs={2}>
                      <StyledIconButton aria-label="delete" size="small" onClick={() => handleDeleteClick(value)}>
                        <ClearIcon fontSize="small" />
                      </StyledIconButton>
                    </IconGrid>
                  </Grid>
                ))}
              <StyledTextField1
                name="values"
                margin="dense"
                variant="outlined"
                value={values}
                onChange={handleTextChange}
                onClick={handleTextChange}
                multiline
                rows={2}
                placeholder="Comma-separated list of values"
                style={{ width: '100%' }}
              />
              <RightContent>
                <BlueButton
                  variant="outlined"
                  onClick={handleAddClick}
                  color="primary"
                  rightGutter={2}
                  disabled={values === ''}
                >
                  <StyledTypography variant="body2" clickable>
                    Add Values
                  </StyledTypography>
                </BlueButton>
              </RightContent>
            </StyledScrollableContainer>

            <LastMenuItem onClick={handleApplyClick}>
              <StyledTypography color="primary" variant="body2">
                Apply
              </StyledTypography>
            </LastMenuItem>
          </DropdownList>
        </AbsoluteContainer>
      )}
    </Container>
  );
};

const BorderedGrid = styled(Grid)`
  border: 1px solid #ddd;
  padding: 0.4rem 1rem;
  margin-bottom: 0.75rem;
  border-radius: 3px;
`;

const Container = styled.div`
  position: relative;
  display: inline;
`;

const IconGrid = styled(Grid)`
  margin: 0.4rem 0 0 0;
  padding-left: 1rem;
`;

const RightContent = styled.div`
  text-align: right;
  margin-top: 0.2rem;
  margin-bottom: 1rem;
  button {
    margin: 0;
  }
`;

const StyledScrollableContainer = styled(ScrollableContainer)`
  padding: 0.5rem 1rem 0 1rem;
`;

const StyledIconButton = styled(IconButton)`
  svg {
    fill: #aaa;
  }
`;

const StyledTextField1 = styled(StyledTextField)`
  textarea {
    font-size: 0.875rem;
  }
`;

const DropdownList = styled.ul`
  background: white;
  width: 375px;
  padding: 0;
  margin: 0;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  li {
    margin-bottom: 0px;
  }
`;

export default CustomFilter;
